import {Injectable} from '@angular/core';
import {BaseService} from "../../../../../../../base/services/base.service";
import {AuthService} from "../../../../auth/services/auth.service";
import {NotifierService} from "../../../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../../../../../base/services/eventbus/event-bus.service";
import {IAuth} from "../../../../../../common/modules/auth/models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class DeleteService extends BaseService {

  constructor(
    authService: AuthService,
    notifier: NotifierService,
    private http: HttpClient,
    private eventBus: EventBusService
  ) {
    super(authService, notifier)
  }

  deleteItem(key: string, requestUrl: string): void {
    this.http.delete(requestUrl)
      .subscribe(res => {
        this.eventBus.publish(key, res)
      }, (error: HttpErrorResponse) => {
        this.handleError(error, (auth: IAuth) => {
          this.deleteItem(key, requestUrl)
        }, (err: HttpErrorResponse) => {
          this.eventBus.publish(this.getErrorKey(key), err)
        })
      })
  }

}
